import {CountryType} from '../interfaces/country-type';
import {AppLanguageTag} from './types';

// From https://bitbucket.org/atlassian/atlaskit-mk-2/raw/4ad0e56649c3e6c973e226b7efaeb28cb240ccb0/packages/core/select/src/data/countries.js
export const countries: readonly CountryType[] = [
  {
    code: 'AD',
    label: {
      [AppLanguageTag.esES]: 'Andorra',
      [AppLanguageTag.glES]: 'Andorra',
      [AppLanguageTag.ptPT]: 'Andorra',
      [AppLanguageTag.enUS]: 'Andorra',
      [AppLanguageTag.ptBR]: 'Andorra',
    },
    phone: '376',
  },
  {
    code: 'AE',
    label: {
      [AppLanguageTag.esES]: 'Emiratos Árabes Unidos',
      [AppLanguageTag.glES]: 'Emiratos Árabes Unidos',
      [AppLanguageTag.ptPT]: 'Emirados Árabes Unidos',
      [AppLanguageTag.enUS]: 'United Arab Emirates',
      [AppLanguageTag.ptBR]: 'Emirados Árabes Unidos',
    },
    phone: '971',
  },
  {
    code: 'AF',
    label: {
      [AppLanguageTag.esES]: 'Afganistán',
      [AppLanguageTag.glES]: 'Afganistán',
      [AppLanguageTag.ptPT]: 'Afeganistão',
      [AppLanguageTag.enUS]: 'Afghanistan',
      [AppLanguageTag.ptBR]: 'Afeganistão',
    },
    phone: '93',
  },
  {
    code: 'AG',
    label: {
      [AppLanguageTag.esES]: 'Antigua y Barbuda',
      [AppLanguageTag.glES]: 'Antigua e Barbuda',
      [AppLanguageTag.ptPT]: 'Antígua e Barbuda',
      [AppLanguageTag.enUS]: 'Antigua and Barbuda',
      [AppLanguageTag.ptBR]: 'Antígua e Barbuda',
    },
    phone: '1-268',
  },
  {
    code: 'AI',
    label: {
      [AppLanguageTag.esES]: 'Anguila',
      [AppLanguageTag.glES]: 'Anguila',
      [AppLanguageTag.ptPT]: 'Anguila',
      [AppLanguageTag.enUS]: 'Anguilla',
      [AppLanguageTag.ptBR]: 'Anguila',
    },
    phone: '1-264',
  },
  {
    code: 'AL',
    label: {
      [AppLanguageTag.esES]: 'Albania',
      [AppLanguageTag.glES]: 'Albania',
      [AppLanguageTag.ptPT]: 'Albânia',
      [AppLanguageTag.enUS]: 'Albania',
      [AppLanguageTag.ptBR]: 'Albânia',
    },
    phone: '355',
  },
  {
    code: 'AM',
    label: {
      [AppLanguageTag.esES]: 'Armenia',
      [AppLanguageTag.glES]: 'Armenia',
      [AppLanguageTag.ptPT]: 'Arménia',
      [AppLanguageTag.enUS]: 'Armenia',
      [AppLanguageTag.ptBR]: 'Armênia',
    },
    phone: '374',
  },
  {
    code: 'AO',
    label: {
      [AppLanguageTag.esES]: 'Angola',
      [AppLanguageTag.glES]: 'Angola',
      [AppLanguageTag.ptPT]: 'Angola',
      [AppLanguageTag.enUS]: 'Angola',
      [AppLanguageTag.ptBR]: 'Angola',
    },
    phone: '244',
  },
  {
    code: 'AQ',
    label: {
      [AppLanguageTag.esES]: 'Antártida',
      [AppLanguageTag.glES]: 'Antártida',
      [AppLanguageTag.ptPT]: 'Antártida',
      [AppLanguageTag.enUS]: 'Antarctica',
      [AppLanguageTag.ptBR]: 'Antártida',
    },
    phone: '672',
  },
  {
    code: 'AR',
    label: {
      [AppLanguageTag.esES]: 'Argentina',
      [AppLanguageTag.glES]: 'Arxentina',
      [AppLanguageTag.ptPT]: 'Argentina',
      [AppLanguageTag.enUS]: 'Argentina',
      [AppLanguageTag.ptBR]: 'Argentina',
    },
    phone: '54',
  },
  {
    code: 'AS',
    label: {
      [AppLanguageTag.esES]: 'Samoa Americana',
      [AppLanguageTag.glES]: 'Samoa Americana',
      [AppLanguageTag.ptPT]: 'Samoa Americana',
      [AppLanguageTag.enUS]: 'American Samoa',
      [AppLanguageTag.ptBR]: 'Samoa Americana',
    },
    phone: '1-684',
  },
  {
    code: 'AT',
    label: {
      [AppLanguageTag.esES]: 'Austria',
      [AppLanguageTag.glES]: 'Austria',
      [AppLanguageTag.ptPT]: 'Áustria',
      [AppLanguageTag.enUS]: 'Austria',
      [AppLanguageTag.ptBR]: 'Áustria',
    },
    phone: '43',
  },
  {
    code: 'AU',
    label: {
      [AppLanguageTag.esES]: 'Australia',
      [AppLanguageTag.glES]: 'Australia',
      [AppLanguageTag.ptPT]: 'Austrália',
      [AppLanguageTag.enUS]: 'Australia',
      [AppLanguageTag.ptBR]: 'Austrália',
    },
    phone: '61',
    suggested: true,
  },
  {
    code: 'AW',
    label: {
      [AppLanguageTag.esES]: 'Aruba',
      [AppLanguageTag.glES]: 'Aruba',
      [AppLanguageTag.ptPT]: 'Aruba',
      [AppLanguageTag.enUS]: 'Aruba',
      [AppLanguageTag.ptBR]: 'Aruba',
    },
    phone: '297',
  },
  {
    code: 'AX',
    label: {
      [AppLanguageTag.esES]: 'Islas Aland',
      [AppLanguageTag.glES]: 'Illas Åland',
      [AppLanguageTag.ptPT]: 'Ilhas Åland',
      [AppLanguageTag.enUS]: 'Åland Islands',
      [AppLanguageTag.ptBR]: 'Ilhas Åland',
    },
    phone: '358',
  },
  {
    code: 'AZ',
    label: {
      [AppLanguageTag.esES]: 'Azerbaiyán',
      [AppLanguageTag.glES]: 'Acerbaixán',
      [AppLanguageTag.ptPT]: 'Azerbaijão',
      [AppLanguageTag.enUS]: 'Azerbaijan',
      [AppLanguageTag.ptBR]: 'Azerbaijão',
    },
    phone: '994',
  },
  {
    code: 'BA',
    label: {
      [AppLanguageTag.esES]: 'Bosnia y Herzegovina',
      [AppLanguageTag.glES]: 'Bosnia e Hercegovina',
      [AppLanguageTag.ptPT]: 'Bósnia-Herzegovina',
      [AppLanguageTag.enUS]: 'Bosnia and Herzegovina',
      [AppLanguageTag.ptBR]: 'Bósnia-Herzegovina',
    },
    phone: '387',
  },
  {
    code: 'BB',
    label: {
      [AppLanguageTag.esES]: 'Barbados',
      [AppLanguageTag.glES]: 'Barbados',
      [AppLanguageTag.ptPT]: 'Barbados',
      [AppLanguageTag.enUS]: 'Barbados',
      [AppLanguageTag.ptBR]: 'Barbados',
    },
    phone: '1-246',
  },
  {
    code: 'BD',
    label: {
      [AppLanguageTag.esES]: 'Bangladés',
      [AppLanguageTag.glES]: 'Bangladesh',
      [AppLanguageTag.ptPT]: 'Bangladesh',
      [AppLanguageTag.enUS]: 'Bangladesh',
      [AppLanguageTag.ptBR]: 'Bangladesh',
    },
    phone: '880',
  },
  {
    code: 'BE',
    label: {
      [AppLanguageTag.esES]: 'Bélgica',
      [AppLanguageTag.glES]: 'Bélxica',
      [AppLanguageTag.ptPT]: 'Bélgica',
      [AppLanguageTag.enUS]: 'Belgium',
      [AppLanguageTag.ptBR]: 'Bélgica',
    },
    phone: '32',
  },
  {
    code: 'BF',
    label: {
      [AppLanguageTag.esES]: 'Burkina Faso',
      [AppLanguageTag.glES]: 'Burkina Faso',
      [AppLanguageTag.ptPT]: 'Burquina Faso',
      [AppLanguageTag.enUS]: 'Burkina Faso',
      [AppLanguageTag.ptBR]: 'Burquina Faso',
    },
    phone: '226',
  },
  {
    code: 'BG',
    label: {
      [AppLanguageTag.esES]: 'Bulgaria',
      [AppLanguageTag.glES]: 'Bulgaria',
      [AppLanguageTag.ptPT]: 'Bulgária',
      [AppLanguageTag.enUS]: 'Bulgaria',
      [AppLanguageTag.ptBR]: 'Bulgária',
    },
    phone: '359',
  },
  {
    code: 'BH',
    label: {
      [AppLanguageTag.esES]: 'Baréin',
      [AppLanguageTag.glES]: 'Bahrein',
      [AppLanguageTag.ptPT]: 'Barém',
      [AppLanguageTag.enUS]: 'Bahrain',
      [AppLanguageTag.ptBR]: 'Barém',
    },
    phone: '973',
  },
  {
    code: 'BI',
    label: {
      [AppLanguageTag.esES]: 'Burundi',
      [AppLanguageTag.glES]: 'Burundi',
      [AppLanguageTag.ptPT]: 'Burúndi',
      [AppLanguageTag.enUS]: 'Burundi',
      [AppLanguageTag.ptBR]: 'Burúndi',
    },
    phone: '257',
  },
  {
    code: 'BJ',
    label: {
      [AppLanguageTag.esES]: 'Benín',
      [AppLanguageTag.glES]: 'Benin',
      [AppLanguageTag.ptPT]: 'Benim',
      [AppLanguageTag.enUS]: 'Benin',
      [AppLanguageTag.ptBR]: 'Benim',
    },
    phone: '229',
  },
  {
    code: 'BL',
    label: {
      [AppLanguageTag.esES]: 'San Bartolomé',
      [AppLanguageTag.glES]: 'San Bartolomeu',
      [AppLanguageTag.ptPT]: 'São Bartolomeu',
      [AppLanguageTag.enUS]: 'Bermuda',
      [AppLanguageTag.ptBR]: 'Bermudas',
    },
    phone: '1-441',
  },
  {
    code: 'BN',
    label: {
      [AppLanguageTag.esES]: 'Brunei Darussalam',
      [AppLanguageTag.glES]: 'Brunei Darussalam',
      [AppLanguageTag.ptPT]: 'Brunei Darussalam',
      [AppLanguageTag.enUS]: 'Brunei Darussalam',
      [AppLanguageTag.ptBR]: 'Brunei Darussalam',
    },
    phone: '673',
  },
  {
    code: 'BO',
    label: {
      [AppLanguageTag.esES]: 'Bolivia',
      [AppLanguageTag.glES]: 'Bolivia',
      [AppLanguageTag.ptPT]: 'Bolívia',
      [AppLanguageTag.enUS]: 'Bolivia',
      [AppLanguageTag.ptBR]: 'Bolívia',
    },
    phone: '591',
  },
  {
    code: 'BR',
    label: {
      [AppLanguageTag.esES]: 'Brasil',
      [AppLanguageTag.glES]: 'Brasil',
      [AppLanguageTag.ptPT]: 'Brasil',
      [AppLanguageTag.enUS]: 'Brazil',
      [AppLanguageTag.ptBR]: 'Brasil',
    },
    phone: '55',
  },
  {
    code: 'BS',
    label: {
      [AppLanguageTag.esES]: 'Bahamas',
      [AppLanguageTag.glES]: 'Bahamas',
      [AppLanguageTag.ptPT]: 'Bahamas',
      [AppLanguageTag.enUS]: 'Bahamas',
      [AppLanguageTag.ptBR]: 'Bahamas',
    },
    phone: '1-242',
  },
  {
    code: 'BT',
    label: {
      [AppLanguageTag.esES]: 'Bután',
      [AppLanguageTag.glES]: 'Bután',
      [AppLanguageTag.ptPT]: 'Butão',
      [AppLanguageTag.enUS]: 'Bhutan',
      [AppLanguageTag.ptBR]: 'Butão',
    },
    phone: '975',
  },
  {
    code: 'BV',
    label: {
      [AppLanguageTag.esES]: 'Isla Bouvet',
      [AppLanguageTag.glES]: 'Illa Bouvet',
      [AppLanguageTag.ptPT]: 'Ilha Bouvet',
      [AppLanguageTag.enUS]: 'Bouvet Island',
      [AppLanguageTag.ptBR]: 'Ilha Bouvet',
    },
    phone: '47',
  },
  {
    code: 'BW',
    label: {
      [AppLanguageTag.esES]: 'Botsuana',
      [AppLanguageTag.glES]: 'Botsuana',
      [AppLanguageTag.ptPT]: 'Botsuana',
      [AppLanguageTag.enUS]: 'Botswana',
      [AppLanguageTag.ptBR]: 'Botsuana',
    },
    phone: '267',
  },
  {
    code: 'BY',
    label: {
      [AppLanguageTag.esES]: 'Bielorrusia',
      [AppLanguageTag.glES]: 'Bielorrusia',
      [AppLanguageTag.ptPT]: 'Bielorrússia',
      [AppLanguageTag.enUS]: 'Belarus',
      [AppLanguageTag.ptBR]: 'Bielorrússia',
    },
    phone: '375',
  },
  {
    code: 'BZ',
    label: {
      [AppLanguageTag.esES]: 'Belice',
      [AppLanguageTag.glES]: 'Belice',
      [AppLanguageTag.ptPT]: 'Belize',
      [AppLanguageTag.enUS]: 'Belize',
      [AppLanguageTag.ptBR]: 'Belize',
    },
    phone: '501',
  },
  {
    code: 'CA',
    label: {
      [AppLanguageTag.esES]: 'Canadá',
      [AppLanguageTag.glES]: 'Canadá',
      [AppLanguageTag.ptPT]: 'Canadá',
      [AppLanguageTag.enUS]: 'Canada',
      [AppLanguageTag.ptBR]: 'Canadá',
    },
    phone: '1',
    suggested: true,
  },
  {
    code: 'CC',
    label: {
      [AppLanguageTag.esES]: 'Islas Cocos (Keeling)',
      [AppLanguageTag.glES]: 'Illas Cocos (Keeling)',
      [AppLanguageTag.ptPT]: 'Ilhas Cocos (Keeling)',
      [AppLanguageTag.enUS]: 'Cocos (Keeling) Islands',
      [AppLanguageTag.ptBR]: 'Ilhas Cocos (Keeling)',
    },
    phone: '61',
  },
  {
    code: 'CD',
    label: {
      [AppLanguageTag.esES]: 'República Democrática del Congo',
      [AppLanguageTag.glES]: 'República Democrática do Congo',
      [AppLanguageTag.ptPT]: 'República Democrática do Congo',
      [AppLanguageTag.enUS]: 'Democratic Republic of the Congo',
      [AppLanguageTag.ptBR]: 'República Democrática do Congo',
    },
    phone: '243',
  },
  {
    code: 'CF',
    label: {
      [AppLanguageTag.esES]: 'República Centroafricana',
      [AppLanguageTag.glES]: 'República Centroafricana',
      [AppLanguageTag.ptPT]: 'República Centro-Africana',
      [AppLanguageTag.enUS]: 'Central African Republic',
      [AppLanguageTag.ptBR]: 'República Centro-Africana',
    },
    phone: '236',
  },
  {
    code: 'CG',
    label: {
      [AppLanguageTag.esES]: 'República del Congo',
      [AppLanguageTag.glES]: 'República do Congo',
      [AppLanguageTag.ptPT]: 'República do Congo',
      [AppLanguageTag.enUS]: 'Republic of the Congo',
      [AppLanguageTag.ptBR]: 'República do Congo',
    },
    phone: '242',
  },
  {
    code: 'CH',
    label: {
      [AppLanguageTag.esES]: 'Suiza',
      [AppLanguageTag.glES]: 'Suíza',
      [AppLanguageTag.ptPT]: 'Suíça',
      [AppLanguageTag.enUS]: 'Switzerland',
      [AppLanguageTag.ptBR]: 'Suíça',
    },
    phone: '41',
  },
  {
    code: 'CI',
    label: {
      [AppLanguageTag.esES]: 'Costa de Marfil',
      [AppLanguageTag.glES]: 'Costa de Marfil',
      [AppLanguageTag.ptPT]: 'Costa do Marfim',
      [AppLanguageTag.enUS]: 'Ivory Coast',
      [AppLanguageTag.ptBR]: 'Costa do Marfim',
    },
    phone: '225',
  },
  {
    code: 'CK',
    label: {
      [AppLanguageTag.esES]: 'Islas Cook',
      [AppLanguageTag.glES]: 'Illas Cook',
      [AppLanguageTag.ptPT]: 'Ilhas Cook',
      [AppLanguageTag.enUS]: 'Cook Islands',
      [AppLanguageTag.ptBR]: 'Ilhas Cook',
    },
    phone: '682',
  },
  {
    code: 'CL',
    label: {
      [AppLanguageTag.esES]: 'Chile',
      [AppLanguageTag.glES]: 'Chile',
      [AppLanguageTag.ptPT]: 'Chile',
      [AppLanguageTag.enUS]: 'Chile',
      [AppLanguageTag.ptBR]: 'Chile',
    },
    phone: '56',
  },
  {
    code: 'CM',
    label: {
      [AppLanguageTag.esES]: 'Camerún',
      [AppLanguageTag.glES]: 'Camerún',
      [AppLanguageTag.ptPT]: 'Camarões',
      [AppLanguageTag.enUS]: 'Cameroon',
      [AppLanguageTag.ptBR]: 'Camarões',
    },
    phone: '237',
  },
  {
    code: 'CN',
    label: {
      [AppLanguageTag.esES]: 'China',
      [AppLanguageTag.glES]: 'China',
      [AppLanguageTag.ptPT]: 'China',
      [AppLanguageTag.enUS]: 'China',
      [AppLanguageTag.ptBR]: 'China',
    },
    phone: '86',
  },
  {
    code: 'CO',
    label: {
      [AppLanguageTag.esES]: 'Colombia',
      [AppLanguageTag.glES]: 'Colombia',
      [AppLanguageTag.ptPT]: 'Colômbia',
      [AppLanguageTag.enUS]: 'Colombia',
      [AppLanguageTag.ptBR]: 'Colômbia',
    },
    phone: '57',
  },
  {
    code: 'CR',
    label: {
      [AppLanguageTag.esES]: 'Costa Rica',
      [AppLanguageTag.glES]: 'Costa Rica',
      [AppLanguageTag.glES]: 'Costa Rica',
      [AppLanguageTag.ptPT]: 'Costa Rica',
      [AppLanguageTag.enUS]: 'Costa Rica',
      [AppLanguageTag.ptBR]: 'Costa Rica',
    },
    phone: '506',
  },
  {
    code: 'CU',
    label: {
      [AppLanguageTag.esES]: 'Cuba',
      [AppLanguageTag.glES]: 'Cuba',
      [AppLanguageTag.ptPT]: 'Cuba',
      [AppLanguageTag.enUS]: 'Cuba',
      [AppLanguageTag.ptBR]: 'Cuba',
    },
    phone: '53',
  },
  {
    code: 'CV',
    label: {
      [AppLanguageTag.esES]: 'Cabo Verde',
      [AppLanguageTag.glES]: 'Cabo Verde',
      [AppLanguageTag.ptPT]: 'Cabo Verde',
      [AppLanguageTag.enUS]: 'Cape Verde',
      [AppLanguageTag.ptBR]: 'Cabo Verde',
    },
    phone: '238',
  },
  {
    code: 'CW',
    label: {
      [AppLanguageTag.esES]: 'Curazao',
      [AppLanguageTag.glES]: 'Curazao',
      [AppLanguageTag.ptPT]: 'Curaçau',
      [AppLanguageTag.enUS]: 'Curaçao',
      [AppLanguageTag.ptBR]: 'Curaçau',
    },
    phone: '599',
  },
  {
    code: 'CX',
    label: {
      [AppLanguageTag.esES]: 'Isla de Navidad',
      [AppLanguageTag.glES]: 'Illa Christmas',
      [AppLanguageTag.ptPT]: 'Ilha do Natal',
      [AppLanguageTag.enUS]: 'Christmas Island',
      [AppLanguageTag.ptBR]: 'Ilha do Natal',
    },
    phone: '61',
  },
  {
    code: 'CY',
    label: {
      [AppLanguageTag.esES]: 'Chipre',
      [AppLanguageTag.glES]: 'Chipre',
      [AppLanguageTag.ptPT]: 'Chipre',
      [AppLanguageTag.enUS]: 'Cyprus',
      [AppLanguageTag.ptBR]: 'Chipre',
    },
    phone: '357',
  },
  {
    code: 'CZ',
    label: {
      [AppLanguageTag.esES]: 'República Checa',
      [AppLanguageTag.glES]: 'República Checa',
      [AppLanguageTag.ptPT]: 'República Checa',
      [AppLanguageTag.enUS]: 'Czech Republic',
      [AppLanguageTag.ptBR]: 'República Checa',
    },
    phone: '420',
  },
  {
    code: 'DE',
    label: {
      [AppLanguageTag.esES]: 'Alemania',
      [AppLanguageTag.glES]: 'Alemaña',
      [AppLanguageTag.ptPT]: 'Alemanha',
      [AppLanguageTag.enUS]: 'Germany',
      [AppLanguageTag.ptBR]: 'Alemanha',
    },
    phone: '49',
    suggested: true,
  },
  {
    code: 'DJ',
    label: {
      [AppLanguageTag.esES]: 'Yibuti',
      [AppLanguageTag.glES]: 'Xibuti',
      [AppLanguageTag.ptPT]: 'Jibuti',
      [AppLanguageTag.enUS]: 'Djibouti',
      [AppLanguageTag.ptBR]: 'Jibuti',
    },
    phone: '253',
  },
  {
    code: 'DK',
    label: {
      [AppLanguageTag.esES]: 'Dinamarca',
      [AppLanguageTag.glES]: 'Dinamarca',
      [AppLanguageTag.ptPT]: 'Dinamarca',
      [AppLanguageTag.enUS]: 'Denmark',
      [AppLanguageTag.ptBR]: 'Dinamarca',
    },
    phone: '45',
  },
  {
    code: 'DM',
    label: {
      [AppLanguageTag.esES]: 'Dominica',
      [AppLanguageTag.glES]: 'Dominica',
      [AppLanguageTag.ptPT]: 'Domínica',
      [AppLanguageTag.enUS]: 'Dominica',
      [AppLanguageTag.ptBR]: 'Domínica',
    },
    phone: '1-767',
  },
  {
    code: 'DO',
    label: {
      [AppLanguageTag.esES]: 'República Dominicana',
      [AppLanguageTag.glES]: 'República Dominicana',
      [AppLanguageTag.ptPT]: 'República Dominicana',
      [AppLanguageTag.enUS]: 'Dominican Republic',
      [AppLanguageTag.ptBR]: 'República Dominicana',
    },
    phone: '1-809',
  },
  {
    code: 'DZ',
    label: {
      [AppLanguageTag.esES]: 'Argelia',
      [AppLanguageTag.glES]: 'Arxelia',
      [AppLanguageTag.ptPT]: 'Argélia',
      [AppLanguageTag.enUS]: 'Algeria',
      [AppLanguageTag.ptBR]: 'Argélia',
    },
    phone: '213',
  },
  {
    code: 'EC',
    label: {
      [AppLanguageTag.esES]: 'Ecuador',
      [AppLanguageTag.glES]: 'Ecuador',
      [AppLanguageTag.ptPT]: 'Equador',
      [AppLanguageTag.enUS]: 'Ecuador',
      [AppLanguageTag.ptBR]: 'Equador',
    },
    phone: '593',
  },
  {
    code: 'EE',
    label: {
      [AppLanguageTag.esES]: 'Estonia',
      [AppLanguageTag.glES]: 'Estonia',
      [AppLanguageTag.ptPT]: 'Estónia',
      [AppLanguageTag.enUS]: 'Estonia',
      [AppLanguageTag.ptBR]: 'Estônia',
    },
    phone: '372',
  },
  {
    code: 'EG',
    label: {
      [AppLanguageTag.esES]: 'Egipto',
      [AppLanguageTag.glES]: 'Exipto',
      [AppLanguageTag.ptPT]: 'Egito',
      [AppLanguageTag.enUS]: 'Egypt',
      [AppLanguageTag.ptBR]: 'Egito',
    },
    phone: '20',
  },
  {
    code: 'EH',
    label: {
      [AppLanguageTag.esES]: 'Sahara Occidental',
      [AppLanguageTag.glES]: 'Sáhara Occidental',
      [AppLanguageTag.ptPT]: 'Saara Ocidental',
      [AppLanguageTag.enUS]: 'Western Sahara',
      [AppLanguageTag.ptBR]: 'Saara Ocidental',
    },
    phone: '212',
  },
  {
    code: 'ER',
    label: {
      [AppLanguageTag.esES]: 'Estado de Eritrea',
      [AppLanguageTag.glES]: 'Eritrea',
      [AppLanguageTag.ptPT]: 'Eritreia',
      [AppLanguageTag.enUS]: 'Eritrea',
      [AppLanguageTag.ptBR]: 'Eritreia',
    },
    phone: '291',
  },
  {
    code: 'ES',
    label: {
      [AppLanguageTag.esES]: 'Espanã',
      [AppLanguageTag.glES]: 'España',
      [AppLanguageTag.ptPT]: 'Espanha',
      [AppLanguageTag.enUS]: 'Spain',
      [AppLanguageTag.ptBR]: 'Espanha',
    },
    phone: '34',
  },
  {
    code: 'ET',
    label: {
      [AppLanguageTag.esES]: 'Etiopía',
      [AppLanguageTag.glES]: 'Etiopía',
      [AppLanguageTag.ptPT]: 'Etiópia',
      [AppLanguageTag.enUS]: 'Ethiopia',
      [AppLanguageTag.ptBR]: 'Etiópia',
    },
    phone: '251',
  },
  {
    code: 'FI',
    label: {
      [AppLanguageTag.esES]: 'Finlandia',
      [AppLanguageTag.glES]: 'Finlandia',
      [AppLanguageTag.ptPT]: 'Finlândia',
      [AppLanguageTag.enUS]: 'Finland',
      [AppLanguageTag.ptBR]: 'Finlândia',
    },
    phone: '358',
  },
  {
    code: 'FJ',
    label: {
      [AppLanguageTag.esES]: 'Fiyi',
      [AppLanguageTag.glES]: 'Fiyi',
      [AppLanguageTag.ptPT]: 'Fiji',
      [AppLanguageTag.enUS]: 'Fiji',
      [AppLanguageTag.ptBR]: 'Fiji',
    },
    phone: '679',
  },
  {
    code: 'FK',
    label: {
      [AppLanguageTag.esES]: 'Islas Malvinas',
      [AppLanguageTag.glES]: 'Illas Malvinas',
      [AppLanguageTag.ptPT]: 'Ilhas Malvinas',
      [AppLanguageTag.enUS]: 'Falkland Islands (Malvinas)',
      [AppLanguageTag.ptBR]: 'Ilhas Malvinas',
    },
    phone: '500',
  },
  {
    code: 'FM',
    label: {
      [AppLanguageTag.esES]: 'Estados Federados de Micronesia',
      [AppLanguageTag.glES]: 'Estados Federados de Micronesia',
      [AppLanguageTag.ptPT]: 'Estados Federados da Micronésia',
      [AppLanguageTag.enUS]: 'Federated States of Micronesia',
      [AppLanguageTag.ptBR]: 'Estados Federados da Micronésia',
    },
    phone: '691',
  },
  {
    code: 'FO',
    label: {
      [AppLanguageTag.esES]: 'Islas Feroe',
      [AppLanguageTag.glES]: 'Illas Feroe',
      [AppLanguageTag.ptPT]: 'Ilhas Faroé',
      [AppLanguageTag.enUS]: 'Faroe Islands',
      [AppLanguageTag.ptBR]: 'Ilhas Faroé',
    },
    phone: '298',
  },
  {
    code: 'FR',
    label: {
      [AppLanguageTag.esES]: 'Francia',
      [AppLanguageTag.glES]: 'Francia',
      [AppLanguageTag.ptPT]: 'França',
      [AppLanguageTag.enUS]: 'France',
      [AppLanguageTag.ptBR]: 'França',
    },
    phone: '33',
    suggested: true,
  },
  {
    code: 'GA',
    label: {
      [AppLanguageTag.esES]: 'Gabón',
      [AppLanguageTag.glES]: 'Gabón',
      [AppLanguageTag.ptPT]: 'Gabão',
      [AppLanguageTag.enUS]: 'Gabon',
      [AppLanguageTag.ptBR]: 'Gabão',
    },
    phone: '241',
  },
  {
    code: 'GB',
    label: {
      [AppLanguageTag.esES]: 'Reino Unido',
      [AppLanguageTag.glES]: 'Reino Unido',
      [AppLanguageTag.ptPT]: 'Reino Unido',
      [AppLanguageTag.enUS]: 'United Kingdom',
      [AppLanguageTag.ptBR]: 'Reino Unido',
    },
    phone: '44',
  },
  {
    code: 'GD',
    label: {
      [AppLanguageTag.esES]: 'Grenada',
      [AppLanguageTag.glES]: 'Granada',
      [AppLanguageTag.ptPT]: 'Grenada',
      [AppLanguageTag.enUS]: 'Grenada',
      [AppLanguageTag.ptBR]: 'Grenada',
    },
    phone: '1-473',
  },
  {
    code: 'GE',
    label: {
      [AppLanguageTag.esES]: 'Georgia',
      [AppLanguageTag.glES]: 'Xeorxia',
      [AppLanguageTag.ptPT]: 'Geórgia',
      [AppLanguageTag.enUS]: 'Georgia',
      [AppLanguageTag.ptBR]: 'Geórgia',
    },
    phone: '995',
  },
  {
    code: 'GF',
    label: {
      [AppLanguageTag.esES]: 'Guayana Francesa',
      [AppLanguageTag.glES]: 'Güiana Francesa',
      [AppLanguageTag.ptPT]: 'Guiana Francesa',
      [AppLanguageTag.enUS]: 'French Guiana',
      [AppLanguageTag.ptBR]: 'Guiana Francesa',
    },
    phone: '594',
  },
  {
    code: 'GG',
    label: {
      [AppLanguageTag.esES]: 'Guernsey',
      [AppLanguageTag.glES]: 'Guernsey',
      [AppLanguageTag.ptPT]: 'Guernsey',
      [AppLanguageTag.enUS]: 'Guernsey',
      [AppLanguageTag.ptBR]: 'Guernsey',
    },
    phone: '44',
  },
  {
    code: 'GH',
    label: {
      [AppLanguageTag.esES]: 'Ghana',
      [AppLanguageTag.glES]: 'Ghana',
      [AppLanguageTag.ptPT]: 'Gana',
      [AppLanguageTag.enUS]: 'Ghana',
      [AppLanguageTag.ptBR]: 'Gana',
    },
    phone: '233',
  },
  {
    code: 'GI',
    label: {
      [AppLanguageTag.esES]: 'Gibraltar',
      [AppLanguageTag.glES]: 'Xibraltar',
      [AppLanguageTag.ptPT]: 'Gibraltar',
      [AppLanguageTag.enUS]: 'Gibraltar',
      [AppLanguageTag.ptBR]: 'Gibraltar',
    },
    phone: '350',
  },
  {
    code: 'GL',
    label: {
      [AppLanguageTag.esES]: 'Groenlandia',
      [AppLanguageTag.glES]: 'Groenlandia',
      [AppLanguageTag.ptPT]: 'Gronelândia',
      [AppLanguageTag.enUS]: 'Greenland',
      [AppLanguageTag.ptBR]: 'Gronelândia',
    },
    phone: '299',
  },
  {
    code: 'GM',
    label: {
      [AppLanguageTag.esES]: 'Gambia',
      [AppLanguageTag.glES]: 'Gambia',
      [AppLanguageTag.ptPT]: 'Gâmbia',
      [AppLanguageTag.enUS]: 'Gambia',
      [AppLanguageTag.ptBR]: 'Gâmbia',
    },
    phone: '220',
  },
  {
    code: 'GN',
    label: {
      [AppLanguageTag.esES]: 'Guinea',
      [AppLanguageTag.glES]: 'Guinea',
      [AppLanguageTag.ptPT]: 'Guiné',
      [AppLanguageTag.enUS]: 'Guinea',
      [AppLanguageTag.ptBR]: 'Guiné',
    },
    phone: '224',
  },
  {
    code: 'GP',
    label: {
      [AppLanguageTag.esES]: 'Guadalupe',
      [AppLanguageTag.glES]: 'Guadalupe',
      [AppLanguageTag.ptPT]: 'Guadalupe',
      [AppLanguageTag.enUS]: 'Guadeloupe',
      [AppLanguageTag.ptBR]: 'Guadalupe',
    },
    phone: '590',
  },
  {
    code: 'GQ',
    label: {
      [AppLanguageTag.esES]: 'Guinea Ecuatorial',
      [AppLanguageTag.glES]: 'Guinea Ecuatorial',
      [AppLanguageTag.ptPT]: 'Guiné Equatorial',
      [AppLanguageTag.enUS]: 'Equatorial Guinea',
      [AppLanguageTag.ptBR]: 'Guiné Equatorial',
    },
    phone: '240',
  },
  {
    code: 'GR',
    label: {
      [AppLanguageTag.esES]: 'Grecia',
      [AppLanguageTag.glES]: 'Grecia',
      [AppLanguageTag.ptPT]: 'Grécia',
      [AppLanguageTag.enUS]: 'Greece',
      [AppLanguageTag.ptBR]: 'Grécia',
    },
    phone: '30',
  },
  {
    code: 'GS',
    label: {
      [AppLanguageTag.esES]: 'Islas Georgias del Sur y Sandwich del Sur',
      [AppLanguageTag.glES]: 'Illas Xeorxias do Sur e Sandwich do Sur',
      [AppLanguageTag.ptPT]: 'Ilhas Geórgia do Sul e Sandwich do Sul',
      [AppLanguageTag.enUS]: 'South Georgia and the South Sandwich Islands',
      [AppLanguageTag.ptBR]: 'Ilhas Geórgia do Sul e Sandwich do Sul',
    },
    phone: '500',
  },
  {
    code: 'GT',
    label: {
      [AppLanguageTag.esES]: 'Guatemala',
      [AppLanguageTag.glES]: 'Guatemala',
      [AppLanguageTag.ptPT]: 'Guatemala',
      [AppLanguageTag.enUS]: 'Guatemala',
      [AppLanguageTag.ptBR]: 'Guatemala',
    },
    phone: '502',
  },
  {
    code: 'GU',
    label: {
      [AppLanguageTag.esES]: 'Guaján',
      [AppLanguageTag.glES]: 'Guam',
      [AppLanguageTag.ptPT]: 'Guão',
      [AppLanguageTag.enUS]: 'Guam',
      [AppLanguageTag.ptBR]: 'Guão',
    },
    phone: '1-671',
  },
  {
    code: 'GW',
    label: {
      [AppLanguageTag.esES]: 'Guinea-Bisáu',
      [AppLanguageTag.glES]: 'Guinea-Bisáu',
      [AppLanguageTag.ptPT]: 'Guiné-Bissau',
      [AppLanguageTag.enUS]: 'Guinea-Bissau',
      [AppLanguageTag.ptBR]: 'Guiné-Bissau',
    },
    phone: '245',
  },
  {
    code: 'GY',
    label: {
      [AppLanguageTag.esES]: 'Guyana',
      [AppLanguageTag.glES]: 'Guyana',
      [AppLanguageTag.ptPT]: 'Guiana',
      [AppLanguageTag.enUS]: 'Guyana',
      [AppLanguageTag.ptBR]: 'Guiana',
    },
    phone: '592',
  },
  {
    code: 'HK',
    label: {
      [AppLanguageTag.esES]: 'Hong Kong',
      [AppLanguageTag.glES]: 'Hong Kong',
      [AppLanguageTag.ptPT]: 'Hong Kong',
      [AppLanguageTag.enUS]: 'Hong Kong',
      [AppLanguageTag.ptBR]: 'Hong Kong',
    },
    phone: '852',
  },
  {
    code: 'HM',
    label: {
      [AppLanguageTag.esES]: 'Islas Heard y McDonald',
      [AppLanguageTag.glES]: 'Illas Heard e McDonald',
      [AppLanguageTag.ptPT]: 'Ilha Heard e as Ilhas McDonald',
      [AppLanguageTag.enUS]: 'Heard Island and McDonald Islands',
      [AppLanguageTag.ptBR]: 'Ilha Heard e as Ilhas McDonald',
    },
    phone: '672',
  },
  {
    code: 'HN',
    label: {
      [AppLanguageTag.esES]: 'Honduras',
      [AppLanguageTag.glES]: 'Honduras',
      [AppLanguageTag.ptPT]: 'Honduras',
      [AppLanguageTag.enUS]: 'Honduras',
      [AppLanguageTag.ptBR]: 'Honduras',
    },
    phone: '504',
  },
  {
    code: 'HR',
    label: {
      [AppLanguageTag.esES]: 'Croacia',
      [AppLanguageTag.glES]: 'Croacia',
      [AppLanguageTag.ptPT]: 'Croácia',
      [AppLanguageTag.enUS]: 'Croatia',
      [AppLanguageTag.ptBR]: 'Croácia',
    },
    phone: '385',
  },
  {
    code: 'HT',
    label: {
      [AppLanguageTag.esES]: 'Haití',
      [AppLanguageTag.glES]: 'Haití',
      [AppLanguageTag.ptPT]: 'Haiti',
      [AppLanguageTag.enUS]: 'Haiti',
      [AppLanguageTag.ptBR]: 'Haiti',
    },
    phone: '509',
  },
  {
    code: 'HU',
    label: {
      [AppLanguageTag.esES]: 'Hungría',
      [AppLanguageTag.glES]: 'Hungría',
      [AppLanguageTag.ptPT]: 'Hungria',
      [AppLanguageTag.enUS]: 'Hungary',
      [AppLanguageTag.ptBR]: 'Hungria',
    },
    phone: '36',
  },
  {
    code: 'ID',
    label: {
      [AppLanguageTag.esES]: 'Indonesia',
      [AppLanguageTag.glES]: 'Indonesia',
      [AppLanguageTag.ptPT]: 'Indonésia',
      [AppLanguageTag.enUS]: 'Indonesia',
      [AppLanguageTag.ptBR]: 'Indonésia',
    },
    phone: '62',
  },
  {
    code: 'IE',
    label: {
      [AppLanguageTag.esES]: 'Irlanda',
      [AppLanguageTag.glES]: 'Irlanda',
      [AppLanguageTag.ptPT]: 'Irlanda',
      [AppLanguageTag.enUS]: 'Ireland',
      [AppLanguageTag.ptBR]: 'Irlanda',
    },
    phone: '353',
  },
  {
    code: 'IL',
    label: {
      [AppLanguageTag.esES]: 'Israel',
      [AppLanguageTag.glES]: 'Israel',
      [AppLanguageTag.ptPT]: 'Israel',
      [AppLanguageTag.enUS]: 'Israel',
      [AppLanguageTag.ptBR]: 'Israel',
    },
    phone: '972',
  },
  {
    code: 'IM',
    label: {
      [AppLanguageTag.esES]: 'Isla de Man',
      [AppLanguageTag.glES]: 'Illa de Man',
      [AppLanguageTag.ptPT]: 'Ilha de Man',
      [AppLanguageTag.enUS]: 'Isle of Man',
      [AppLanguageTag.ptBR]: 'Ilha de Man',
    },
    phone: '44',
  },
  {
    code: 'IN',
    label: {
      [AppLanguageTag.esES]: 'India',
      [AppLanguageTag.glES]: 'India',
      [AppLanguageTag.ptPT]: 'Índia',
      [AppLanguageTag.enUS]: 'India',
      [AppLanguageTag.ptBR]: 'Índia',
    },
    phone: '91',
  },
  {
    code: 'IO',
    label: {
      [AppLanguageTag.esES]: 'Territorio Británico del Océano Índico',
      [AppLanguageTag.glES]: 'Territorio Británico do Océano Índico',
      [AppLanguageTag.ptPT]: 'Território Britânico do Oceano Índico',
      [AppLanguageTag.enUS]: 'British Indian Ocean Territory',
      [AppLanguageTag.ptBR]: 'Território Britânico do Oceano Índico',
    },
    phone: '246',
  },
  {
    code: 'IQ',
    label: {
      [AppLanguageTag.esES]: 'Irak',
      [AppLanguageTag.glES]: 'Iraq',
      [AppLanguageTag.ptPT]: 'Iraque',
      [AppLanguageTag.enUS]: 'Iraq',
      [AppLanguageTag.ptBR]: 'Iraque',
    },
    phone: '964',
  },
  {
    code: 'IR',
    label: {
      [AppLanguageTag.esES]: 'Irán',
      [AppLanguageTag.glES]: 'Irán',
      [AppLanguageTag.ptPT]: 'Irão',
      [AppLanguageTag.enUS]: 'Iran',
      [AppLanguageTag.ptBR]: 'Irã',
    },
    phone: '98',
  },
  {
    code: 'IS',
    label: {
      [AppLanguageTag.esES]: 'Islandia',
      [AppLanguageTag.glES]: 'Islandia',
      [AppLanguageTag.ptPT]: 'Islândia',
      [AppLanguageTag.enUS]: 'Iceland',
      [AppLanguageTag.ptBR]: 'Islândia',
    },
    phone: '354',
  },
  {
    code: 'IT',
    label: {
      [AppLanguageTag.esES]: 'Italia',
      [AppLanguageTag.glES]: 'Italia',
      [AppLanguageTag.ptPT]: 'Itália',
      [AppLanguageTag.enUS]: 'Italy',
      [AppLanguageTag.ptBR]: 'Itália',
    },
    phone: '39',
  },
  {
    code: 'JE',
    label: {
      [AppLanguageTag.esES]: 'Jersey',
      [AppLanguageTag.glES]: 'Jersey',
      [AppLanguageTag.ptPT]: 'Jersey',
      [AppLanguageTag.enUS]: 'Jersey',
      [AppLanguageTag.ptBR]: 'Jersey',
    },
    phone: '44',
  },
  {
    code: 'JM',
    label: {
      [AppLanguageTag.esES]: 'Jamaica',
      [AppLanguageTag.glES]: 'Xamaica',
      [AppLanguageTag.ptPT]: 'Jamaica',
      [AppLanguageTag.enUS]: 'Jamaica',
      [AppLanguageTag.ptBR]: 'Jamaica',
    },
    phone: '1-876',
  },
  {
    code: 'JO',
    label: {
      [AppLanguageTag.esES]: 'Jordania',
      [AppLanguageTag.glES]: 'Xordania',
      [AppLanguageTag.ptPT]: 'Jordânia',
      [AppLanguageTag.enUS]: 'Jordan',
      [AppLanguageTag.ptBR]: 'Jordânia',
    },
    phone: '962',
  },
  {
    code: 'JP',
    label: {
      [AppLanguageTag.esES]: 'Japón',
      [AppLanguageTag.glES]: 'Xapón',
      [AppLanguageTag.ptPT]: 'Japão',
      [AppLanguageTag.enUS]: 'Japan',
      [AppLanguageTag.ptBR]: 'Japão',
    },
    phone: '81',
    suggested: true,
  },
  {
    code: 'KE',
    label: {
      [AppLanguageTag.esES]: 'Kenia',
      [AppLanguageTag.glES]: 'Kenia',
      [AppLanguageTag.ptPT]: 'Quénia',
      [AppLanguageTag.enUS]: 'Kenya',
      [AppLanguageTag.ptBR]: 'Quênia',
    },
    phone: '254',
  },
  {
    code: 'KG',
    label: {
      [AppLanguageTag.esES]: 'Kirguistán',
      [AppLanguageTag.glES]: 'Kirguistán',
      [AppLanguageTag.ptPT]: 'Quirguistão',
      [AppLanguageTag.enUS]: 'Kyrgyzstan',
      [AppLanguageTag.ptBR]: 'Quirguistão',
    },
    phone: '996',
  },
  {
    code: 'KH',
    label: {
      [AppLanguageTag.esES]: 'Camboya',
      [AppLanguageTag.glES]: 'Camboxa',
      [AppLanguageTag.ptPT]: 'Camboja',
      [AppLanguageTag.enUS]: 'Cambodia',
      [AppLanguageTag.ptBR]: 'Camboja',
    },
    phone: '855',
  },
  {
    code: 'KI',
    label: {
      [AppLanguageTag.esES]: 'Kiribati',
      [AppLanguageTag.glES]: 'Kiribati',
      [AppLanguageTag.ptPT]: 'Quiribáti',
      [AppLanguageTag.enUS]: 'Kiribati',
      [AppLanguageTag.ptBR]: 'Quiribáti',
    },
    phone: '686',
  },
  {
    code: 'KM',
    label: {
      [AppLanguageTag.esES]: 'Comoras',
      [AppLanguageTag.glES]: 'Comoras',
      [AppLanguageTag.ptPT]: 'Comores',
      [AppLanguageTag.enUS]: 'Comoros',
      [AppLanguageTag.ptBR]: 'Comores',
    },
    phone: '269',
  },
  {
    code: 'KN',
    label: {
      [AppLanguageTag.esES]: 'San Cristóbal y Nieves',
      [AppLanguageTag.glES]: 'San Cristovo e Nevis',
      [AppLanguageTag.ptPT]: 'São Cristóvão e Neves',
      [AppLanguageTag.enUS]: 'Saint Kitts and Nevis',
      [AppLanguageTag.ptBR]: 'São Cristóvão e Neves',
    },
    phone: '1-869',
  },
  {
    code: 'KP',
    label: {
      [AppLanguageTag.esES]: 'Corea del Norte',
      [AppLanguageTag.glES]: 'Corea do Norte',
      [AppLanguageTag.ptPT]: 'Coreia do Norte',
      [AppLanguageTag.enUS]: 'North Korea',
      [AppLanguageTag.ptBR]: 'Coreia do Norte',
    },
    phone: '850',
  },
  {
    code: 'KR',
    label: {
      [AppLanguageTag.esES]: 'Corea del Sur',
      [AppLanguageTag.glES]: 'Corea do Sur',
      [AppLanguageTag.ptPT]: 'Coreia do Sul',
      [AppLanguageTag.enUS]: 'South Korea',
      [AppLanguageTag.ptBR]: 'Coreia do Sul',
    },
    phone: '82',
  },
  {
    code: 'KW',
    label: {
      [AppLanguageTag.esES]: 'Kuwait',
      [AppLanguageTag.glES]: 'Kuwait',
      [AppLanguageTag.ptPT]: 'Kuwait',
      [AppLanguageTag.enUS]: 'Kuwait',
      [AppLanguageTag.ptBR]: 'Kuwait',
    },
    phone: '965',
  },
  {
    code: 'KY',
    label: {
      [AppLanguageTag.esES]: 'Islas Caimán',
      [AppLanguageTag.glES]: 'Illas Caimán',
      [AppLanguageTag.ptPT]: 'Ilhas Caimã',
      [AppLanguageTag.enUS]: 'Cayman Islands',
      [AppLanguageTag.ptBR]: 'Ilhas Caimã',
    },
    phone: '1-345',
  },
  {
    code: 'KZ',
    label: {
      [AppLanguageTag.esES]: 'Kazajistán',
      [AppLanguageTag.glES]: 'Kazajistán',
      [AppLanguageTag.ptPT]: 'Cazaquistão',
      [AppLanguageTag.enUS]: 'Kazakhstan',
      [AppLanguageTag.ptBR]: 'Cazaquistão',
    },
    phone: '7',
  },
  {
    code: 'LA',
    label: {
      [AppLanguageTag.esES]: 'Laos',
      [AppLanguageTag.glES]: 'Laos',
      [AppLanguageTag.ptPT]: 'Laos',
      [AppLanguageTag.enUS]: 'Laos',
      [AppLanguageTag.ptBR]: 'Laos',
    },
    phone: '856',
  },
  {
    code: 'LB',
    label: {
      [AppLanguageTag.esES]: 'Líbano',
      [AppLanguageTag.glES]: 'Líbano',
      [AppLanguageTag.ptPT]: 'Líbano',
      [AppLanguageTag.enUS]: 'Lebanon',
      [AppLanguageTag.ptBR]: 'Líbano',
    },
    phone: '961',
  },
  {
    code: 'LC',
    label: {
      [AppLanguageTag.esES]: 'Santa Lucía',
      [AppLanguageTag.glES]: 'Santa Lucía',
      [AppLanguageTag.ptPT]: 'Santa Lúcia',
      [AppLanguageTag.enUS]: 'Saint Lucia',
      [AppLanguageTag.ptBR]: 'Santa Lúcia',
    },
    phone: '1-758',
  },
  {
    code: 'LI',
    label: {
      [AppLanguageTag.esES]: 'Liechtenstein',
      [AppLanguageTag.glES]: 'Liechtenstein',
      [AppLanguageTag.ptPT]: 'Liechtenstein',
      [AppLanguageTag.enUS]: 'Liechtenstein',
      [AppLanguageTag.ptBR]: 'Liechtenstein',
    },
    phone: '423',
  },
  {
    code: 'LK',
    label: {
      [AppLanguageTag.esES]: 'Sri Lanka',
      [AppLanguageTag.glES]: 'Sri Lanka',
      [AppLanguageTag.ptPT]: 'Sri Lanka',
      [AppLanguageTag.enUS]: 'Sri Lanka',
      [AppLanguageTag.ptBR]: 'Sri Lanka',
    },
    phone: '94',
  },
  {
    code: 'LR',
    label: {
      [AppLanguageTag.esES]: 'Liberia',
      [AppLanguageTag.glES]: 'Liberia',
      [AppLanguageTag.ptPT]: 'Libéria',
      [AppLanguageTag.enUS]: 'Liberia',
      [AppLanguageTag.ptBR]: 'Libéria',
    },
    phone: '231',
  },
  {
    code: 'LS',
    label: {
      [AppLanguageTag.esES]: 'Lesoto',
      [AppLanguageTag.glES]: 'Lesoto',
      [AppLanguageTag.ptPT]: 'Lesoto',
      [AppLanguageTag.enUS]: 'Lesotho',
      [AppLanguageTag.ptBR]: 'Lesoto',
    },
    phone: '266',
  },
  {
    code: 'LT',
    label: {
      [AppLanguageTag.esES]: 'Lituania',
      [AppLanguageTag.glES]: 'Lituania',
      [AppLanguageTag.ptPT]: 'Lituânia',
      [AppLanguageTag.enUS]: 'Lithuania',
      [AppLanguageTag.ptBR]: 'Lituânia',
    },
    phone: '370',
  },
  {
    code: 'LU',
    label: {
      [AppLanguageTag.esES]: 'Luxemburgo',
      [AppLanguageTag.glES]: 'Luxemburgo',
      [AppLanguageTag.ptPT]: 'Luxemburgo',
      [AppLanguageTag.enUS]: 'Luxembourg',
      [AppLanguageTag.ptBR]: 'Luxemburgo',
    },
    phone: '352',
  },
  {
    code: 'LV',
    label: {
      [AppLanguageTag.esES]: 'Letonia',
      [AppLanguageTag.glES]: 'Letonia',
      [AppLanguageTag.ptPT]: 'Letónia',
      [AppLanguageTag.enUS]: 'Latvia',
      [AppLanguageTag.ptBR]: 'Letônia',
    },
    phone: '371',
  },
  {
    code: 'LY',
    label: {
      [AppLanguageTag.esES]: 'Libia',
      [AppLanguageTag.glES]: 'Libia',
      [AppLanguageTag.ptPT]: 'Líbia',
      [AppLanguageTag.enUS]: 'Libya',
      [AppLanguageTag.ptBR]: 'Líbia',
    },
    phone: '218',
  },
  {
    code: 'MA',
    label: {
      [AppLanguageTag.esES]: 'Marruecos',
      [AppLanguageTag.glES]: 'Marrocos',
      [AppLanguageTag.ptPT]: 'Marrocos',
      [AppLanguageTag.enUS]: 'Morocco',
      [AppLanguageTag.ptBR]: 'Marrocos',
    },
    phone: '212',
  },
  {
    code: 'MC',
    label: {
      [AppLanguageTag.esES]: 'Mónaco',
      [AppLanguageTag.glES]: 'Mónaco',
      [AppLanguageTag.ptPT]: 'Mónaco',
      [AppLanguageTag.enUS]: 'Monaco',
      [AppLanguageTag.ptBR]: 'Mônaco',
    },
    phone: '377',
  },
  {
    code: 'MD',
    label: {
      [AppLanguageTag.esES]: 'Moldavia',
      [AppLanguageTag.glES]: 'Moldavia',
      [AppLanguageTag.ptPT]: 'Moldávia',
      [AppLanguageTag.enUS]: 'Moldova',
      [AppLanguageTag.ptBR]: 'Moldávia',
    },
    phone: '373',
  },
  {
    code: 'ME',
    label: {
      [AppLanguageTag.esES]: 'Montenegro',
      [AppLanguageTag.glES]: 'Montenegro',
      [AppLanguageTag.ptPT]: 'Montenegro',
      [AppLanguageTag.enUS]: 'Montenegro',
      [AppLanguageTag.ptBR]: 'Montenegro',
    },
    phone: '382',
  },
  {
    code: 'MF',
    label: {
      [AppLanguageTag.esES]: 'San Martín (Francia)',
      [AppLanguageTag.glES]: 'San Martín (Francia)',
      [AppLanguageTag.ptPT]: 'São Martinho (França)',
      [AppLanguageTag.enUS]: 'Saint Martin (French part)',
      [AppLanguageTag.ptBR]: 'São Martinho (França)',
    },
    phone: '590',
  },
  {
    code: 'MG',
    label: {
      [AppLanguageTag.esES]: 'Madagascar',
      [AppLanguageTag.glES]: 'Madagascar',
      [AppLanguageTag.ptPT]: 'Madagáscar',
      [AppLanguageTag.enUS]: 'Madagascar',
      [AppLanguageTag.ptBR]: 'Madagáscar',
    },
    phone: '261',
  },
  {
    code: 'MH',
    label: {
      [AppLanguageTag.esES]: 'Islas Marshall',
      [AppLanguageTag.glES]: 'Illas Marshall',
      [AppLanguageTag.ptPT]: 'Ilhas Marshall',
      [AppLanguageTag.enUS]: 'Marshall Islands',
      [AppLanguageTag.ptBR]: 'Ilhas Marshall',
    },
    phone: '692',
  },
  {
    code: 'MK',
    label: {
      [AppLanguageTag.esES]: 'Macedonia del Norte',
      [AppLanguageTag.glES]: 'Macedonia do Norte',
      [AppLanguageTag.ptPT]: 'Macedónia do Norte',
      [AppLanguageTag.enUS]: 'North Macedonia',
      [AppLanguageTag.ptBR]: 'Macedônia do Norte',
    },
    phone: '389',
  },
  {
    code: 'ML',
    label: {
      [AppLanguageTag.esES]: 'Malí',
      [AppLanguageTag.glES]: 'Malí',
      [AppLanguageTag.ptPT]: 'Mali',
      [AppLanguageTag.enUS]: 'Mali',
      [AppLanguageTag.ptBR]: 'Mali',
    },
    phone: '223',
  },
  {
    code: 'MM',
    label: {
      [AppLanguageTag.esES]: 'Myanmar',
      [AppLanguageTag.glES]: 'Myanmar',
      [AppLanguageTag.ptPT]: 'Myanmar',
      [AppLanguageTag.enUS]: 'Myanmar',
      [AppLanguageTag.ptBR]: 'Myanmar',
    },
    phone: '95',
  },
  {
    code: 'MN',
    label: {
      [AppLanguageTag.esES]: 'Mongolia',
      [AppLanguageTag.glES]: 'Mongolia',
      [AppLanguageTag.ptPT]: 'Mongólia',
      [AppLanguageTag.enUS]: 'Mongolia',
      [AppLanguageTag.ptBR]: 'Mongólia',
    },
    phone: '976',
  },
  {
    code: 'MO',
    label: {
      [AppLanguageTag.esES]: 'Macao',
      [AppLanguageTag.glES]: 'Macau',
      [AppLanguageTag.ptPT]: 'Macau',
      [AppLanguageTag.enUS]: 'Macao',
      [AppLanguageTag.ptBR]: 'Macau',
    },
    phone: '853',
  },
  {
    code: 'MP',
    label: {
      [AppLanguageTag.esES]: 'Islas Marianas del Norte',
      [AppLanguageTag.glES]: 'Illas Marianas do Norte',
      [AppLanguageTag.ptPT]: 'Ilhas Marianas do Norte',
      [AppLanguageTag.enUS]: 'Northern Mariana Islands',
      [AppLanguageTag.ptBR]: 'Ilhas Marianas do Norte',
    },
    phone: '1-670',
  },
  {
    code: 'MQ',
    label: {
      [AppLanguageTag.esES]: 'Martinica',
      [AppLanguageTag.glES]: 'Martinica',
      [AppLanguageTag.ptPT]: 'Martinica',
      [AppLanguageTag.enUS]: 'Martinique',
      [AppLanguageTag.ptBR]: 'Martinica',
    },
    phone: '596',
  },
  {
    code: 'MR',
    label: {
      [AppLanguageTag.esES]: 'Mauritania',
      [AppLanguageTag.glES]: 'Mauritania',
      [AppLanguageTag.ptPT]: 'Mauritânia',
      [AppLanguageTag.enUS]: 'Mauritania',
      [AppLanguageTag.ptBR]: 'Mauritânia',
    },
    phone: '222',
  },
  {
    code: 'MS',
    label: {
      [AppLanguageTag.esES]: 'Montserrat',
      [AppLanguageTag.glES]: 'Montserrat',
      [AppLanguageTag.ptPT]: 'Monserrate',
      [AppLanguageTag.enUS]: 'Montserrat',
      [AppLanguageTag.ptBR]: 'Monserrate',
    },
    phone: '1-664',
  },
  {
    code: 'MT',
    label: {
      [AppLanguageTag.esES]: 'Malta',
      [AppLanguageTag.glES]: 'Malta',
      [AppLanguageTag.ptPT]: 'Malta',
      [AppLanguageTag.enUS]: 'Malta',
      [AppLanguageTag.ptBR]: 'Malta',
    },
    phone: '356',
  },
  {
    code: 'MU',
    label: {
      [AppLanguageTag.esES]: 'Mauricio',
      [AppLanguageTag.glES]: 'Mauricio',
      [AppLanguageTag.ptPT]: 'Maurícia',
      [AppLanguageTag.enUS]: 'Mauritius',
      [AppLanguageTag.ptBR]: 'Maurícia',
    },
    phone: '230',
  },
  {
    code: 'MV',
    label: {
      [AppLanguageTag.esES]: 'Maldivas',
      [AppLanguageTag.glES]: 'Maldivas',
      [AppLanguageTag.ptPT]: 'Maldivas',
      [AppLanguageTag.enUS]: 'Maldives',
      [AppLanguageTag.ptBR]: 'Maldivas',
    },
    phone: '960',
  },
  {
    code: 'MW',
    label: {
      [AppLanguageTag.esES]: 'Malaui',
      [AppLanguageTag.glES]: 'Malaui',
      [AppLanguageTag.ptPT]: 'Malawi',
      [AppLanguageTag.enUS]: 'Malawi',
      [AppLanguageTag.ptBR]: 'Malawi',
    },
    phone: '265',
  },
  {
    code: 'MX',
    label: {
      [AppLanguageTag.esES]: 'México',
      [AppLanguageTag.glES]: 'México',
      [AppLanguageTag.ptPT]: 'México',
      [AppLanguageTag.enUS]: 'Mexico',
      [AppLanguageTag.ptBR]: 'México',
    },
    phone: '52',
  },
  {
    code: 'MY',
    label: {
      [AppLanguageTag.esES]: 'Malasia',
      [AppLanguageTag.glES]: 'Malasia',
      [AppLanguageTag.ptPT]: 'Malásia',
      [AppLanguageTag.enUS]: 'Malaysia',
      [AppLanguageTag.ptBR]: 'Malásia',
    },
    phone: '60',
  },
  {
    code: 'MZ',
    label: {
      [AppLanguageTag.esES]: 'Mozambique',
      [AppLanguageTag.glES]: 'Mozambique',
      [AppLanguageTag.ptPT]: 'Moçambique',
      [AppLanguageTag.enUS]: 'Mozambique',
      [AppLanguageTag.ptBR]: 'Moçambique',
    },
    phone: '258',
  },
  {
    code: 'NA',
    label: {
      [AppLanguageTag.esES]: 'Namibia',
      [AppLanguageTag.glES]: 'Namibia',
      [AppLanguageTag.ptPT]: 'Namíbia',
      [AppLanguageTag.enUS]: 'Namibia',
      [AppLanguageTag.ptBR]: 'Namíbia',
    },
    phone: '264',
  },
  {
    code: 'NC',
    label: {
      [AppLanguageTag.esES]: 'Nueva Caledonia',
      [AppLanguageTag.glES]: 'Nova Caledonia',
      [AppLanguageTag.ptPT]: 'Nova Caledónia',
      [AppLanguageTag.enUS]: 'New Caledonia',
      [AppLanguageTag.ptBR]: 'Nova Caledônia',
    },
    phone: '687',
  },
  {
    code: 'NE',
    label: {
      [AppLanguageTag.esES]: 'Níger',
      [AppLanguageTag.glES]: 'Níxer',
      [AppLanguageTag.ptPT]: 'Níger',
      [AppLanguageTag.enUS]: 'Niger',
      [AppLanguageTag.ptBR]: 'Níger',
    },
    phone: '227',
  },
  {
    code: 'NF',
    label: {
      [AppLanguageTag.esES]: 'Isla Norfolk',
      [AppLanguageTag.glES]: 'Illa Norfolk',
      [AppLanguageTag.ptPT]: 'Ilha Norfolk',
      [AppLanguageTag.enUS]: 'Norfolk Island',
      [AppLanguageTag.ptBR]: 'Ilha Norfolk',
    },
    phone: '672',
  },
  {
    code: 'NG',
    label: {
      [AppLanguageTag.esES]: 'Nigeria',
      [AppLanguageTag.glES]: 'Nixeria',
      [AppLanguageTag.ptPT]: 'Nigéria',
      [AppLanguageTag.enUS]: 'Nigeria',
      [AppLanguageTag.ptBR]: 'Nigéria',
    },
    phone: '234',
  },
  {
    code: 'NI',
    label: {
      [AppLanguageTag.esES]: 'Nicaragua',
      [AppLanguageTag.glES]: 'Nicaragua',
      [AppLanguageTag.ptPT]: 'Nicarágua',
      [AppLanguageTag.enUS]: 'Nicaragua',
      [AppLanguageTag.ptBR]: 'Nicarágua',
    },
    phone: '505',
  },
  {
    code: 'NL',
    label: {
      [AppLanguageTag.esES]: 'Países Bajos',
      [AppLanguageTag.glES]: 'Países Baixos',
      [AppLanguageTag.ptPT]: 'Países Baixos',
      [AppLanguageTag.enUS]: 'Netherlands',
      [AppLanguageTag.ptBR]: 'Países Baixos',
    },
    phone: '31',
  },
  {
    code: 'NO',
    label: {
      [AppLanguageTag.esES]: 'Noruega',
      [AppLanguageTag.glES]: 'Noruega',
      [AppLanguageTag.ptPT]: 'Noruega',
      [AppLanguageTag.enUS]: 'Norway',
      [AppLanguageTag.ptBR]: 'Noruega',
    },
    phone: '47',
  },
  {
    code: 'NP',
    label: {
      [AppLanguageTag.esES]: 'Nepal',
      [AppLanguageTag.glES]: 'Nepal',
      [AppLanguageTag.ptPT]: 'Nepal',
      [AppLanguageTag.enUS]: 'Nepal',
      [AppLanguageTag.ptBR]: 'Nepal',
    },
    phone: '977',
  },
  {
    code: 'NR',
    label: {
      [AppLanguageTag.esES]: 'Nauru',
      [AppLanguageTag.glES]: 'Nauru',
      [AppLanguageTag.ptPT]: 'Nauru',
      [AppLanguageTag.enUS]: 'Nauru',
      [AppLanguageTag.ptBR]: 'Nauru',
    },
    phone: '674',
  },
  {
    code: 'NU',
    label: {
      [AppLanguageTag.esES]: 'Niue',
      [AppLanguageTag.glES]: 'Niue',
      [AppLanguageTag.ptPT]: 'Niue',
      [AppLanguageTag.enUS]: 'Niue',
      [AppLanguageTag.ptBR]: 'Niue',
    },
    phone: '683',
  },
  {
    code: 'NZ',
    label: {
      [AppLanguageTag.esES]: 'Nueva Zelanda',
      [AppLanguageTag.glES]: 'Nova Celandia',
      [AppLanguageTag.ptPT]: 'Nova Zelândia',
      [AppLanguageTag.enUS]: 'New Zealand',
      [AppLanguageTag.ptBR]: 'Nova Zelândia',
    },
    phone: '64',
  },
  {
    code: 'OM',
    label: {
      [AppLanguageTag.esES]: 'Omán',
      [AppLanguageTag.glES]: 'Omán',
      [AppLanguageTag.ptPT]: 'Omã',
      [AppLanguageTag.enUS]: 'Oman',
      [AppLanguageTag.ptBR]: 'Omã',
    },
    phone: '968',
  },
  {
    code: 'PA',
    label: {
      [AppLanguageTag.esES]: 'Panamá',
      [AppLanguageTag.glES]: 'Panamá',
      [AppLanguageTag.ptPT]: 'Panamá',
      [AppLanguageTag.enUS]: 'Panama',
      [AppLanguageTag.ptBR]: 'Panamá',
    },
    phone: '507',
  },
  {
    code: 'PE',
    label: {
      [AppLanguageTag.esES]: 'Perú',
      [AppLanguageTag.glES]: 'Perú',
      [AppLanguageTag.ptPT]: 'Peru',
      [AppLanguageTag.enUS]: 'Peru',
      [AppLanguageTag.ptBR]: 'Peru',
    },
    phone: '51',
  },
  {
    code: 'PF',
    label: {
      [AppLanguageTag.esES]: 'Polinesia Francesa',
      [AppLanguageTag.glES]: 'Polinesia Francesa',
      [AppLanguageTag.ptPT]: 'Polinésia Francesa',
      [AppLanguageTag.enUS]: 'French Polynesia',
      [AppLanguageTag.ptBR]: 'Polinésia Francesa',
    },
    phone: '689',
  },
  {
    code: 'PG',
    label: {
      [AppLanguageTag.esES]: 'Papúa Nueva Guinea',
      [AppLanguageTag.glES]: 'Papúa Nova Guinea',
      [AppLanguageTag.ptPT]: 'Papua-Nova Guiné',
      [AppLanguageTag.enUS]: 'Papua New Guinea',
      [AppLanguageTag.ptBR]: 'Papua-Nova Guiné',
    },
    phone: '675',
  },
  {
    code: 'PH',
    label: {
      [AppLanguageTag.esES]: 'Filipinas',
      [AppLanguageTag.glES]: 'Filipinas',
      [AppLanguageTag.ptPT]: 'Filipinas',
      [AppLanguageTag.enUS]: 'Philippines',
      [AppLanguageTag.ptBR]: 'Filipinas',
    },
    phone: '63',
  },
  {
    code: 'PK',
    label: {
      [AppLanguageTag.esES]: 'Pakistán',
      [AppLanguageTag.glES]: 'Paquistán',
      [AppLanguageTag.ptPT]: 'Paquistão',
      [AppLanguageTag.enUS]: 'Pakistan',
      [AppLanguageTag.ptBR]: 'Paquistão',
    },
    phone: '92',
  },
  {
    code: 'PL',
    label: {
      [AppLanguageTag.esES]: 'Polonia',
      [AppLanguageTag.glES]: 'Polonia',
      [AppLanguageTag.ptPT]: 'Polónia',
      [AppLanguageTag.enUS]: 'Poland',
      [AppLanguageTag.ptBR]: 'Polônia',
    },
    phone: '48',
  },
  {
    code: 'PM',
    label: {
      [AppLanguageTag.esES]: 'San Pedro y Miquelón',
      [AppLanguageTag.glES]: 'San Pedro e Miquelón',
      [AppLanguageTag.ptPT]: 'São Pedro e Miquelão',
      [AppLanguageTag.enUS]: 'Saint Pierre and Miquelon',
      [AppLanguageTag.ptBR]: 'São Pedro e Miquelão',
    },
    phone: '508',
  },
  {
    code: 'PN',
    label: {
      [AppLanguageTag.esES]: 'Islas Pitcairn',
      [AppLanguageTag.glES]: 'Illas Pitcairn',
      [AppLanguageTag.ptPT]: 'Ilhas Pitcairn',
      [AppLanguageTag.enUS]: 'Pitcairn Islands',
      [AppLanguageTag.ptBR]: 'Ilhas Pitcairn',
    },
    phone: '870',
  },
  {
    code: 'PR',
    label: {
      [AppLanguageTag.esES]: 'Puerto Rico',
      [AppLanguageTag.glES]: 'Porto Rico',
      [AppLanguageTag.ptPT]: 'Porto Rico',
      [AppLanguageTag.enUS]: 'Puerto Rico',
      [AppLanguageTag.ptBR]: 'Porto Rico',
    },
    phone: '1',
  },
  {
    code: 'PS',
    label: {
      [AppLanguageTag.esES]: 'Estado de Palestina',
      [AppLanguageTag.glES]: 'Estado de Palestina',
      [AppLanguageTag.ptPT]: 'Estado da Palestina',
      [AppLanguageTag.enUS]: 'State of Palestine',
      [AppLanguageTag.ptBR]: 'Estado da Palestina',
    },
    phone: '970',
  },
  {
    code: 'PT',
    label: {
      [AppLanguageTag.esES]: 'Portugal',
      [AppLanguageTag.glES]: 'Portugal',
      [AppLanguageTag.ptPT]: 'Portugal',
      [AppLanguageTag.enUS]: 'Portugal',
      [AppLanguageTag.ptBR]: 'Portugal',
    },
    phone: '351',
  },
  {
    code: 'PW',
    label: {
      [AppLanguageTag.esES]: 'Palaos',
      [AppLanguageTag.glES]: 'Palau',
      [AppLanguageTag.ptPT]: 'Palau',
      [AppLanguageTag.enUS]: 'Palau',
      [AppLanguageTag.ptBR]: 'Palau',
    },
    phone: '680',
  },
  {
    code: 'PY',
    label: {
      [AppLanguageTag.esES]: 'Paraguay',
      [AppLanguageTag.glES]: 'Paraguai',
      [AppLanguageTag.ptPT]: 'Paraguai',
      [AppLanguageTag.enUS]: 'Paraguay',
      [AppLanguageTag.ptBR]: 'Paraguai',
    },
    phone: '595',
  },
  {
    code: 'QA',
    label: {
      [AppLanguageTag.esES]: 'Catar',
      [AppLanguageTag.glES]: 'Qatar',
      [AppLanguageTag.ptPT]: 'Catar',
      [AppLanguageTag.enUS]: 'Qatar',
      [AppLanguageTag.ptBR]: 'Catar',
    },
    phone: '974',
  },
  {
    code: 'RE',
    label: {
      [AppLanguageTag.esES]: 'Reunión',
      [AppLanguageTag.glES]: 'Reunión',
      [AppLanguageTag.ptPT]: 'Reunião',
      [AppLanguageTag.enUS]: 'Reunion',
      [AppLanguageTag.ptBR]: 'Reunião',
    },
    phone: '262',
  },
  {
    code: 'RO',
    label: {
      [AppLanguageTag.esES]: 'Rumania',
      [AppLanguageTag.glES]: 'Romania',
      [AppLanguageTag.ptPT]: 'Roménia',
      [AppLanguageTag.enUS]: 'Romania',
      [AppLanguageTag.ptBR]: 'Romênia',
    },
    phone: '40',
  },
  {
    code: 'RS',
    label: {
      [AppLanguageTag.esES]: 'Serbia',
      [AppLanguageTag.glES]: 'Serbia',
      [AppLanguageTag.ptPT]: 'Sérvia',
      [AppLanguageTag.enUS]: 'Serbia',
      [AppLanguageTag.ptBR]: 'Sérvia',
    },
    phone: '381',
  },
  {
    code: 'RU',
    label: {
      [AppLanguageTag.esES]: 'Rusia',
      [AppLanguageTag.glES]: 'Rusia',
      [AppLanguageTag.ptPT]: 'Rússia',
      [AppLanguageTag.enUS]: 'Russia',
      [AppLanguageTag.ptBR]: 'Rússia',
    },
    phone: '7',
  },
  {
    code: 'RW',
    label: {
      [AppLanguageTag.esES]: 'Ruanda',
      [AppLanguageTag.glES]: 'Ruanda',
      [AppLanguageTag.ptPT]: 'Ruanda',
      [AppLanguageTag.enUS]: 'Rwanda',
      [AppLanguageTag.ptBR]: 'Ruanda',
    },
    phone: '250',
  },
  {
    code: 'SA',
    label: {
      [AppLanguageTag.esES]: 'Arabia Saudita',
      [AppLanguageTag.glES]: 'Arabia Saudita',
      [AppLanguageTag.ptPT]: 'Arábia Saudita',
      [AppLanguageTag.enUS]: 'Saudi Arabia',
      [AppLanguageTag.ptBR]: 'Arábia Saudita',
    },
    phone: '966',
  },
  {
    code: 'SB',
    label: {
      [AppLanguageTag.esES]: 'Islas Salomón',
      [AppLanguageTag.glES]: 'Illas Salomón',
      [AppLanguageTag.ptPT]: 'Ilhas Salomão',
      [AppLanguageTag.enUS]: 'Solomon Islands',
      [AppLanguageTag.ptBR]: 'Ilhas Salomão',
    },
    phone: '677',
  },
  {
    code: 'SC',
    label: {
      [AppLanguageTag.esES]: 'Seychelles',
      [AppLanguageTag.glES]: 'Seicheles',
      [AppLanguageTag.glES]: 'Seicheles',
      [AppLanguageTag.ptPT]: 'Seicheles',
      [AppLanguageTag.enUS]: 'Seychelles',
      [AppLanguageTag.ptBR]: 'Seicheles',
    },
    phone: '248',
  },
  {
    code: 'SD',
    label: {
      [AppLanguageTag.esES]: 'Sudán',
      [AppLanguageTag.glES]: 'Sudán',
      [AppLanguageTag.ptPT]: 'Sudão',
      [AppLanguageTag.enUS]: 'Sudan',
      [AppLanguageTag.ptBR]: 'Sudão',
    },
    phone: '249',
  },
  {
    code: 'SE',
    label: {
      [AppLanguageTag.esES]: 'Suecia',
      [AppLanguageTag.glES]: 'Suecia',
      [AppLanguageTag.ptPT]: 'Suécia',
      [AppLanguageTag.enUS]: 'Sweden',
      [AppLanguageTag.ptBR]: 'Suécia',
    },
    phone: '46',
  },
  {
    code: 'SG',
    label: {
      [AppLanguageTag.esES]: 'Singapur',
      [AppLanguageTag.glES]: 'Singapur',
      [AppLanguageTag.ptPT]: 'Singapura',
      [AppLanguageTag.enUS]: 'Singapore',
      [AppLanguageTag.ptBR]: 'Singapura',
    },
    phone: '65',
  },
  {
    code: 'SH',
    label: {
      [AppLanguageTag.esES]: 'Santa Elena',
      [AppLanguageTag.glES]: 'Santa Helena',
      [AppLanguageTag.ptPT]: 'Santa Helena',
      [AppLanguageTag.enUS]: 'Saint Helena',
      [AppLanguageTag.ptBR]: 'Santa Helena',
    },
    phone: '290',
  },
  {
    code: 'SI',
    label: {
      [AppLanguageTag.esES]: 'Eslovenia',
      [AppLanguageTag.glES]: 'Eslovenia',
      [AppLanguageTag.ptPT]: 'Eslovénia',
      [AppLanguageTag.enUS]: 'Slovenia',
      [AppLanguageTag.ptBR]: 'Eslovênia',
    },
    phone: '386',
  },
  {
    code: 'SJ',
    label: {
      [AppLanguageTag.esES]: 'Svalbard y Jan Mayen',
      [AppLanguageTag.glES]: 'Svalbard e Jan Mayen',
      [AppLanguageTag.ptPT]: 'Svalbard e Jan Mayen',
      [AppLanguageTag.enUS]: 'Svalbard and Jan Mayen',
      [AppLanguageTag.ptBR]: 'Svalbard e Jan Mayen',
    },
    phone: '47',
  },
  {
    code: 'SK',
    label: {
      [AppLanguageTag.esES]: 'Eslovaquia',
      [AppLanguageTag.glES]: 'Eslovaquia',
      [AppLanguageTag.ptPT]: 'Eslováquia',
      [AppLanguageTag.enUS]: 'Slovakia',
      [AppLanguageTag.ptBR]: 'Eslováquia',
    },
    phone: '421',
  },
  {
    code: 'SL',
    label: {
      [AppLanguageTag.esES]: 'Sierra Leona',
      [AppLanguageTag.glES]: 'Serra Leoa',
      [AppLanguageTag.ptPT]: 'Serra Leoa',
      [AppLanguageTag.enUS]: 'Sierra Leone',
      [AppLanguageTag.ptBR]: 'Serra Leoa',
    },
    phone: '232',
  },
  {
    code: 'SM',
    label: {
      [AppLanguageTag.esES]: 'San Marino',
      [AppLanguageTag.glES]: 'San Marino',
      [AppLanguageTag.ptPT]: 'San Marino',
      [AppLanguageTag.enUS]: 'San Marino',
      [AppLanguageTag.ptBR]: 'San Marino',
    },
    phone: '378',
  },
  {
    code: 'SN',
    label: {
      [AppLanguageTag.esES]: 'Senegal',
      [AppLanguageTag.glES]: 'Senegal',
      [AppLanguageTag.ptPT]: 'Senegal',
      [AppLanguageTag.enUS]: 'Senegal',
      [AppLanguageTag.ptBR]: 'Senegal',
    },
    phone: '221',
  },
  {
    code: 'SO',
    label: {
      [AppLanguageTag.esES]: 'Somalia',
      [AppLanguageTag.glES]: 'Somalia',
      [AppLanguageTag.ptPT]: 'Somália',
      [AppLanguageTag.enUS]: 'Somalia',
      [AppLanguageTag.ptBR]: 'Somália',
    },
    phone: '252',
  },
  {
    code: 'SR',
    label: {
      [AppLanguageTag.esES]: 'Surinam',
      [AppLanguageTag.glES]: 'Surinam',
      [AppLanguageTag.ptPT]: 'Suriname',
      [AppLanguageTag.enUS]: 'Suriname',
      [AppLanguageTag.ptBR]: 'Suriname',
    },
    phone: '597',
  },
  {
    code: 'SS',
    label: {
      [AppLanguageTag.esES]: 'Sudán del Sur',
      [AppLanguageTag.glES]: 'Sudán do Sur',
      [AppLanguageTag.ptPT]: 'Sudão do Sul',
      [AppLanguageTag.enUS]: 'South Sudan',
      [AppLanguageTag.ptBR]: 'Sudão do Sul',
    },
    phone: '211',
  },
  {
    code: 'ST',
    label: {
      [AppLanguageTag.esES]: 'Santo Tomé y Príncipe',
      [AppLanguageTag.glES]: 'Santo Tomé e Príncipe',
      [AppLanguageTag.ptPT]: 'São Tomé e Príncipe',
      [AppLanguageTag.enUS]: 'Sao Tome and Principe',
      [AppLanguageTag.ptBR]: 'São Tomé e Príncipe',
    },
    phone: '239',
  },
  {
    code: 'SV',
    label: {
      [AppLanguageTag.esES]: 'El Salvador',
      [AppLanguageTag.glES]: 'El Salvador',
      [AppLanguageTag.ptPT]: 'El Salvador',
      [AppLanguageTag.enUS]: 'El Salvador',
      [AppLanguageTag.ptBR]: 'El Salvador',
    },
    phone: '503',
  },
  {
    code: 'SX',
    label: {
      [AppLanguageTag.esES]: 'San Martín (Países Bajos)',
      [AppLanguageTag.glES]: 'San Martín (Países Baixos)',
      [AppLanguageTag.ptPT]: 'São Martinho (Países Baixos)',
      [AppLanguageTag.enUS]: 'Sint Maarten (Dutch part)',
      [AppLanguageTag.ptBR]: 'São Martinho (Países Baixos)',
    },
    phone: '1-721',
  },
  {
    code: 'SY',
    label: {
      [AppLanguageTag.esES]: 'Siria',
      [AppLanguageTag.glES]: 'Siria',
      [AppLanguageTag.ptPT]: 'Síria',
      [AppLanguageTag.enUS]: 'Syrian Arab Republic',
      [AppLanguageTag.ptBR]: 'Síria',
    },
    phone: '963',
  },
  {
    code: 'SZ',
    label: {
      [AppLanguageTag.esES]: 'Suazilandia',
      [AppLanguageTag.glES]: 'Suazilandia',
      [AppLanguageTag.ptPT]: 'Essuatíni',
      [AppLanguageTag.enUS]: 'Swaziland',
      [AppLanguageTag.ptBR]: 'Essuatíni',
    },
    phone: '268',
  },
  {
    code: 'TC',
    label: {
      [AppLanguageTag.esES]: 'Islas Turcas y Caicos',
      [AppLanguageTag.glES]: 'Illas Turcas e Caicos',
      [AppLanguageTag.ptPT]: 'Ilhas Turcas e Caicos',
      [AppLanguageTag.enUS]: 'Turks and Caicos Islands',
      [AppLanguageTag.ptBR]: 'Ilhas Turcas e Caicos',
    },
    phone: '1-649',
  },
  {
    code: 'TD',
    label: {
      [AppLanguageTag.esES]: 'Chad',
      [AppLanguageTag.glES]: 'Chade',
      [AppLanguageTag.ptPT]: 'Chade',
      [AppLanguageTag.enUS]: 'Chad',
      [AppLanguageTag.ptBR]: 'Chade',
    },
    phone: '235',
  },
  {
    code: 'TF',
    label: {
      [AppLanguageTag.esES]: 'Tierras Australes y Antárticas Francesas',
      [AppLanguageTag.glES]: 'Terras Austrais e Antárticas Francesas',
      [AppLanguageTag.ptPT]: 'Terras Austrais e Antárticas Francesas',
      [AppLanguageTag.enUS]: 'French Southern and Antarctic Territories',
      [AppLanguageTag.ptBR]: 'Terras Austrais e Antárticas Francesas',
    },
    phone: '262',
  },
  {
    code: 'TG',
    label: {
      [AppLanguageTag.esES]: 'Togo',
      [AppLanguageTag.glES]: 'Togo',
      [AppLanguageTag.ptPT]: 'Togo',
      [AppLanguageTag.enUS]: 'Togo',
      [AppLanguageTag.ptBR]: 'Togo',
    },
    phone: '228',
  },
  {
    code: 'TH',
    label: {
      [AppLanguageTag.esES]: 'Tailandia',
      [AppLanguageTag.glES]: 'Tailandia',
      [AppLanguageTag.ptPT]: 'Tailândia',
      [AppLanguageTag.enUS]: 'Thailand',
      [AppLanguageTag.ptBR]: 'Tailândia',
    },
    phone: '66',
  },
  {
    code: 'TJ',
    label: {
      [AppLanguageTag.esES]: 'Tayikistán',
      [AppLanguageTag.glES]: 'Taxiquistán',
      [AppLanguageTag.ptPT]: 'Tajiquistão',
      [AppLanguageTag.enUS]: 'Tajikistan',
      [AppLanguageTag.ptBR]: 'Tajiquistão',
    },
    phone: '992',
  },
  {
    code: 'TK',
    label: {
      [AppLanguageTag.esES]: 'Tokelau',
      [AppLanguageTag.glES]: 'Tokelau',
      [AppLanguageTag.ptPT]: 'Toquelau',
      [AppLanguageTag.enUS]: 'Tokelau',
      [AppLanguageTag.ptBR]: 'Toquelau',
    },
    phone: '690',
  },
  {
    code: 'TL',
    label: {
      [AppLanguageTag.esES]: 'Timor Oriental',
      [AppLanguageTag.glES]: 'Timor-Leste',
      [AppLanguageTag.ptPT]: 'Timor-Leste',
      [AppLanguageTag.enUS]: 'Timor-Leste',
      [AppLanguageTag.ptBR]: 'Timor-Leste',
    },
    phone: '670',
  },
  {
    code: 'TM',
    label: {
      [AppLanguageTag.esES]: 'Turkmenistán',
      [AppLanguageTag.glES]: 'Turkmenistán',
      [AppLanguageTag.ptPT]: 'Turquemenistão',
      [AppLanguageTag.enUS]: 'Turkmenistan',
      [AppLanguageTag.ptBR]: 'Turquemenistão',
    },
    phone: '993',
  },
  {
    code: 'TN',
    label: {
      [AppLanguageTag.esES]: 'Túnez',
      [AppLanguageTag.glES]: 'Tunisia',
      [AppLanguageTag.ptPT]: 'Tunísia',
      [AppLanguageTag.enUS]: 'Tunisia',
      [AppLanguageTag.ptBR]: 'Tunísia',
    },
    phone: '216',
  },
  {
    code: 'TO',
    label: {
      [AppLanguageTag.esES]: 'Tonga',
      [AppLanguageTag.glES]: 'Tonga',
      [AppLanguageTag.ptPT]: 'Tonga',
      [AppLanguageTag.enUS]: 'Tonga',
      [AppLanguageTag.ptBR]: 'Tonga',
    },
    phone: '676',
  },
  {
    code: 'TR',
    label: {
      [AppLanguageTag.esES]: 'Turquía',
      [AppLanguageTag.glES]: 'Turquía',
      [AppLanguageTag.ptPT]: 'Turquia',
      [AppLanguageTag.enUS]: 'Turkey',
      [AppLanguageTag.ptBR]: 'Turquia',
    },
    phone: '90',
  },
  {
    code: 'TT',
    label: {
      [AppLanguageTag.esES]: 'Trinidad y Tobago',
      [AppLanguageTag.glES]: 'Trinidad e Tobago',
      [AppLanguageTag.ptPT]: 'Trindade e Tobago',
      [AppLanguageTag.enUS]: 'Trinidad and Tobago',
      [AppLanguageTag.ptBR]: 'Trindade e Tobago',
    },
    phone: '1-868',
  },
  {
    code: 'TV',
    label: {
      [AppLanguageTag.esES]: 'Tuvalu',
      [AppLanguageTag.glES]: 'Tuvalu',
      [AppLanguageTag.ptPT]: 'Tuvalu',
      [AppLanguageTag.enUS]: 'Tuvalu',
      [AppLanguageTag.ptBR]: 'Tuvalu',
    },
    phone: '688',
  },
  {
    code: 'TW',
    label: {
      [AppLanguageTag.esES]: 'Provincia de Taiwán (República Popular China)',
      [AppLanguageTag.glES]: 'Provincia de Taiwán (República Popular China)',
      [AppLanguageTag.ptPT]: 'Província de Taiwan (República Popular da China)',
      [AppLanguageTag.enUS]: "Taiwan Province (People's Republic of China)",
      [AppLanguageTag.ptBR]: 'Província de Taiwan (República Popular da China)',
    },
    phone: '886',
  },
  {
    code: 'TZ',
    label: {
      [AppLanguageTag.esES]: 'Tanzania',
      [AppLanguageTag.glES]: 'Tanzania',
      [AppLanguageTag.ptPT]: 'Tanzânia',
      [AppLanguageTag.enUS]: 'Tanzania',
      [AppLanguageTag.ptBR]: 'Tanzânia',
    },
    phone: '255',
  },
  {
    code: 'UA',
    label: {
      [AppLanguageTag.esES]: 'Ucrania',
      [AppLanguageTag.glES]: 'Ucraína',
      [AppLanguageTag.ptPT]: 'Ucrânia',
      [AppLanguageTag.enUS]: 'Ukraine',
      [AppLanguageTag.ptBR]: 'Ucrânia',
    },
    phone: '380',
  },
  {
    code: 'UG',
    label: {
      [AppLanguageTag.esES]: 'Uganda',
      [AppLanguageTag.glES]: 'Uganda',
      [AppLanguageTag.ptPT]: 'Uganda',
      [AppLanguageTag.enUS]: 'Uganda',
      [AppLanguageTag.ptBR]: 'Uganda',
    },
    phone: '256',
  },
  {
    code: 'US',
    label: {
      [AppLanguageTag.esES]: 'Estados Unidos',
      [AppLanguageTag.glES]: 'Estados Unidos',
      [AppLanguageTag.ptPT]: 'Estados Unidos',
      [AppLanguageTag.enUS]: 'United States',
      [AppLanguageTag.ptBR]: 'Estados Unidos',
    },
    phone: '1',
    suggested: true,
  },
  {
    code: 'UY',
    label: {
      [AppLanguageTag.esES]: 'Uruguay',
      [AppLanguageTag.glES]: 'Uruguai',
      [AppLanguageTag.ptPT]: 'Uruguai',
      [AppLanguageTag.enUS]: 'Uruguay',
      [AppLanguageTag.ptBR]: 'Uruguai',
    },
    phone: '598',
  },
  {
    code: 'UZ',
    label: {
      [AppLanguageTag.esES]: 'Uzbekistán',
      [AppLanguageTag.glES]: 'Uzbekistán',
      [AppLanguageTag.ptPT]: 'Uzbequistão',
      [AppLanguageTag.enUS]: 'Uzbekistan',
      [AppLanguageTag.ptBR]: 'Uzbequistão',
    },
    phone: '998',
  },
  {
    code: 'VA',
    label: {
      [AppLanguageTag.esES]: 'Santa Sede (Estado de la Ciudad del Vaticano)',
      [AppLanguageTag.glES]: 'Santa Sé (Estado da Cidade do Vaticano)',
      [AppLanguageTag.ptPT]: 'Santa Sé (Cidade-Estado do Vaticano)',
      [AppLanguageTag.enUS]: 'Holy See (Vatican City State)',
      [AppLanguageTag.ptBR]: 'Santa Sé (Cidade-Estado do Vaticano)',
    },
    phone: '379',
  },
  {
    code: 'VC',
    label: {
      [AppLanguageTag.esES]: 'San Vicente y las Granadinas',
      [AppLanguageTag.glES]: 'San Vicente e as Granadinas',
      [AppLanguageTag.ptPT]: 'São Vicente e Granadinas',
      [AppLanguageTag.enUS]: 'Saint Vincent and the Grenadines',
      [AppLanguageTag.ptBR]: 'São Vicente e Granadinas',
    },
    phone: '1-784',
  },
  {
    code: 'VE',
    label: {
      [AppLanguageTag.esES]: 'Venezuela',
      [AppLanguageTag.glES]: 'Venezuela',
      [AppLanguageTag.ptPT]: 'Venezuela',
      [AppLanguageTag.enUS]: 'Venezuela',
      [AppLanguageTag.ptBR]: 'Venezuela',
    },
    phone: '58',
  },
  {
    code: 'VG',
    label: {
      [AppLanguageTag.esES]: 'Islas Vírgenes Británicas',
      [AppLanguageTag.glES]: 'Illas Virxes Británicas',
      [AppLanguageTag.ptPT]: 'Ilhas Virgens Britânicas',
      [AppLanguageTag.enUS]: 'British Virgin Islands',
      [AppLanguageTag.ptBR]: 'Ilhas Virgens Britânicas',
    },
    phone: '1-284',
  },
  {
    code: 'VI',
    label: {
      [AppLanguageTag.esES]: 'Islas Vírgenes de los Estados Unidos',
      [AppLanguageTag.glES]: 'Illas Virxes dos Estados Unidos',
      [AppLanguageTag.ptPT]: 'Ilhas Virgens dos Estados Unidos',
      [AppLanguageTag.enUS]: 'United States Virgin Islands',
      [AppLanguageTag.ptBR]: 'Ilhas Virgens dos Estados Unidos',
    },
    phone: '1-340',
  },
  {
    code: 'VN',
    label: {
      [AppLanguageTag.esES]: 'Vietnam',
      [AppLanguageTag.glES]: 'Vietnam',
      [AppLanguageTag.ptPT]: 'Vietname',
      [AppLanguageTag.enUS]: 'Vietnam',
      [AppLanguageTag.ptBR]: 'Vietnã',
    },
    phone: '84',
  },
  {
    code: 'VU',
    label: {
      [AppLanguageTag.esES]: 'Vanuatu',
      [AppLanguageTag.glES]: 'Vanuatu',
      [AppLanguageTag.ptPT]: 'Vanuatu',
      [AppLanguageTag.enUS]: 'Vanuatu',
      [AppLanguageTag.ptBR]: 'Vanuatu',
    },
    phone: '678',
  },
  {
    code: 'WF',
    label: {
      [AppLanguageTag.esES]: 'Wallis y Futuna',
      [AppLanguageTag.glES]: 'Wallis e Futuna',
      [AppLanguageTag.ptPT]: 'Wallis e Futuna',
      [AppLanguageTag.enUS]: 'Wallis and Futuna',
      [AppLanguageTag.ptBR]: 'Wallis e Futuna',
    },
    phone: '681',
  },
  {
    code: 'WS',
    label: {
      [AppLanguageTag.esES]: 'Samoa',
      [AppLanguageTag.glES]: 'Samoa',
      [AppLanguageTag.ptPT]: 'Samoa',
      [AppLanguageTag.enUS]: 'Samoa',
      [AppLanguageTag.ptBR]: 'Samoa',
    },
    phone: '685',
  },
  {
    code: 'XK',
    label: {
      [AppLanguageTag.esES]: 'Kosovo',
      [AppLanguageTag.glES]: 'Kosovo',
      [AppLanguageTag.ptPT]: 'Kosovo',
      [AppLanguageTag.enUS]: 'Kosovo',
      [AppLanguageTag.ptBR]: 'Kosovo',
    },
    phone: '383',
  },
  {
    code: 'YE',
    label: {
      [AppLanguageTag.esES]: 'Yemen',
      [AppLanguageTag.glES]: 'Iemen',
      [AppLanguageTag.ptPT]: 'Iémen',
      [AppLanguageTag.enUS]: 'Yemen',
      [AppLanguageTag.ptBR]: 'Iêmen',
    },
    phone: '967',
  },
  {
    code: 'YT',
    label: {
      [AppLanguageTag.esES]: 'Mayotte',
      [AppLanguageTag.glES]: 'Mayotte',
      [AppLanguageTag.ptPT]: 'Maiote',
      [AppLanguageTag.enUS]: 'Mayotte',
      [AppLanguageTag.ptBR]: 'Maiote',
    },
    phone: '262',
  },
  {
    code: 'ZA',
    label: {
      [AppLanguageTag.esES]: 'Sudáfrica',
      [AppLanguageTag.glES]: 'Sudáfrica',
      [AppLanguageTag.ptPT]: 'África do Sul',
      [AppLanguageTag.enUS]: 'South Africa',
      [AppLanguageTag.ptBR]: 'África do Sul',
    },
    phone: '27',
  },
  {
    code: 'ZM',
    label: {
      [AppLanguageTag.esES]: 'Zambia',
      [AppLanguageTag.glES]: 'Zambia',
      [AppLanguageTag.ptPT]: 'Zâmbia',
      [AppLanguageTag.enUS]: 'Zambia',
      [AppLanguageTag.ptBR]: 'Zâmbia',
    },
    phone: '260',
  },
  {
    code: 'ZW',
    label: {
      [AppLanguageTag.esES]: 'Zimbabue',
      [AppLanguageTag.glES]: 'Zimbabue',
      [AppLanguageTag.ptPT]: 'Zimbabué',
      [AppLanguageTag.enUS]: 'Zimbabwe',
      [AppLanguageTag.ptBR]: 'Zimbábue',
    },
    phone: '263',
  },
];
